<template>
  <div class="reporting">
    <Top :isTeacher="isTeacher" />
    <div class="report_tab">
      <van-tabs v-model="active" type="card" class="report_my_tab" @click="handleChangeTab">
        <van-tab title="每日记录" class="forms_list">
          <div class="name_wrap">
            <div class="name_input_wrap" @click="handleShowPeople">
              <span>姓名</span>
              <div class="name_input">
                <span>{{name}}</span>
                <img src="../assets/images/icon-down.png"/>
              </div>
            </div>
            <span class="add_people" @click="handleToNewPeople">编辑上报人</span>
          </div>

          <div v-for="(item, index) in questions" :key="index">
            <h1 class="ques_title"><span v-if="item.required == 1">*</span>{{item.title}}</h1>
            <!-- 单选 -->
            <RadioItem
              :ref="'radioRef' + item.questionId"
              v-if="item.type == 'radio'"
              :options="item.options"
              :order="item.questionId"
              @onRadio="handleRadioClick"
            />
            <!-- 单选填空 -->
            <RadioItem
              :ref="'radioRef' + item.questionId"
              v-if="item.type == 'radio_blank'"
              :options="item.options"
              :order="item.questionId"
              :input="true"
              :placeholder="item.place"
              @onRadio="handleRadioClick"
              @value="handleRadioBlackClick"
            />
            <!-- 填空文本域 -->
            <div class="area_wrap" v-if="item.type == 'blank'">
              <van-field class="text_area" v-model="others" type="textarea" maxlength="100" :show-word-limit="true" />
            </div>
            <!-- 地点选择 -->
            <div class="address_wrap" v-if="item.type == 'address'">
              <div class="addr_selects" @click="handleShowArea">
                <span>{{areaVal ? areaVal : '点击选择所在地'}}</span>
                <img src="../assets/images/icon-down.png"/>
              </div>
              <van-field class="text_input" placeholder="请填写详细地址" maxlength="30" v-model="detailAddr" type="text" />
            </div>
            <!-- 单选单选 -->
            <RadioItem
              :ref="'radioRef' + item.questionId"
              v-if="item.type == 'radio_radio'"
              :options="item.options"
              :order="item.questionId"
              :isRadio="true"
              @onRadio="handleRadioClick"
              @onSecondRadio="handleRadioRadioClick"
            />
            <!-- 填空 -->
            <div class="blank_input" v-if="item.type == 'blank_input'">
              <van-field class="text_input" placeholder="请输入今日体温" maxlength="5" v-model="configTemp" type="number" /><span>℃</span>
            </div>
            <!-- 单图片上传 -->
            <FormUpload :ref="'uploadRef' + item.questionId" v-if="item.type == 'upload'" :order="item.questionId" @onUp="handleUpload" />
            <!-- 多图片上传 -->
            <FormUploads :ref="'uploadsRef' + item.questionId" v-if="item.type == 'upload-multiple'" :order="item.questionId" @onUp="handleUpload" />
          </div>

          <div class="btn_wrap">
            <FormButton
              title="提交"
              :showLoading="showLoading"
              @onEmit="handleSubmitClick"
            />
          </div>

          <p class="from">山东广电信通网络运营有限公司提供技术支持</p>
        </van-tab>

        <van-tab title="上报记录" class="record_list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="handleLoad"
          >
            <RecordItem v-for="(item, index) in records" :key="index" :info="item" />
          </van-list>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 姓名列表弹框 -->
    <van-popup v-model="showPeopleList" position="bottom">
      <div class="pop_school">
        <div
          v-for="(item, index) in nameList"
          :key="index"
          class="select_item"
          :class="{'select_item_ac': item.id == nameId}"
          @click="handleChoosePeople(item)"
        >
          <p>{{item.name}}</p>
        </div>
      </div>
    </van-popup>

    <!-- 省市区三级联动弹框 -->
    <van-popup v-model="showAreaList" position="bottom" :close-on-click-overlay="false">
      <van-area title="省市区" :area-list="areaList" @cancel="handleCloseArea" @confirm="handleConfirmArea" />
    </van-popup>
  </div>
</template>

<script>
import Top from '../components/Top'
import RadioItem from '../components/RadioItem'
import { tmpData, symData, questions } from '../commen/constants'
import FormButton from '../components/FormButton'
import RecordItem from '../components/RecordItem'
import FormUpload from '../components/FormUpload'
import FormUploads from '../components/FormUploads'
import { get, post } from '../commen/http'
import { getUrlParam } from "../commen/util";
import area from '../commen/area';
export default {
  components: {
    Top,
    RadioItem,
    FormButton,
    RecordItem,
    FormUpload,
    FormUploads
  },
  data() {
    return {
      active: 0, // tab切换id
      areaList: area, // 省市区数据列表
      showAreaList: false, // 是否展示

      tmp: tmpData, // 
      sym: symData,

      loading: false, // 长列表加载
      finished: false, // 长列表加载完成

      nameList: [], // 填报人列表
      nameId: '', // 填报人id
      name: '', // 填报人姓名

      showPeopleList: false, // 填报人弹框展示

      temperatureStatus: '', // 体温是否高于37.3
      temperature: '', // 具体的体温
      symptomStatus: '', // 是否有症状的id
      others: '', // 其他

      records: [], // 填报记录列表
      page: 1,
      showLoading: false,
      isTeacher: getUrlParam("isT"),

      leaveWeiId: '', // 14日内是否离开过本市
      citys: '', // 具体去过哪些城市

      dangerId: '', // 中高风险地区旅行史
      dangerPoints: '', // 去过的中高风险地区

      peopleId: '', // 中高风险地区归来人员密切接触
      orgid: getUrlParam("_orgid_"), // 机构id
      questions: [], // 问题列表
      isClose: '', // 今日小区是否封闭
      isTure: '', // 是否有确诊疑似病例
      isLeave: '', // 今日本人是否外出
      leavePoint: '', // 今日本人去过的地点
      areaVal: '', // 省市区
      detailAddr: '', // 详细地址
      isAsid: '', // 是否核酸
      asidResult: '', // 核酸结果
      isAbroad: '', // 是否境外来本市
      abroadArea: '', // 从哪里来本市
      configTemp: '', // 今日具体体温
      todayAcid: '', // 今日是否核酸
      yesterdayAcid: '', // 昨日是否核酸
      checkStatus: '', // 是否为应检尽检人员
      healthImg: '',
      travelImg: '',
      acidImg: '',
      commonImg: [], // 共同居住人核酸检测报告
    }
  },
  methods: {
    // 获取上报人列表
    async fetchPeople() {
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/health/reporter'
      })
      if(res.code === 1) {
        this.nameList = res.data;
        this.name = res.data[0].name;
        this.nameId = res.data[0].id;
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    },

    // 获取题目列表
    async fetchQuestions() {
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/health/page'
      })
      if(res.code == 1) {
        this.questions = res.data;
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
      
    },

    // 获取radio选择的信息
    handleRadioClick(radio, order) {
      switch (order) {
        case 1:
          this.temperatureStatus = radio;
          break;
        case 2:
          this.symptomStatus = radio;
          break;
        case 5:
          this.isClose = radio;
          break;
        case 6:
          this.isTure = radio;
          break;
        case 7:
          this.isAsid = radio;
          break;
        case 8:
          this.isLeave = radio;
          break;
        case 9:
          this.leaveWeiId = radio;
          break;
        case 10:
          this.dangerId = radio;
          break;
        case 11:
          this.peopleId = radio;
          break;
        case 12:
          this.isAbroad = radio;
          break;
        case 14:
          this.todayAcid = radio;
          break;
        case 15:
          this.yesterdayAcid = radio;
          break;
        case 16:
          this.checkStatus = radio;
          break;
        default:
          break;
      }
    },

    // 获取单选填空的信息
    handleRadioBlackClick(value, order) {
      switch (order) {
        case 1:
          this.temperature = value;
          break;
        case 8:
          this.leavePoint = value;
          break;
        case 9:
          this.citys = value;
          break;
        case 10:
          this.dangerPoints = value;
          break;
        case 12:
          this.abroadArea = value
          break;
        default:
          break;
      }
    },

    // 获取上传信息
    handleUpload(value, order) {
      switch (order) {
        case 17:
          this.healthImg = value;
          break;
        case 18:
          this.travelImg = value;
          break;
        case 19:
          this.acidImg = value;
          break;
        case 20:
          this.commonImg = value
          break;
        default:
          break;
      }
    },

    // 获取单选单选的信息
    handleRadioRadioClick(value, order) {
      this.asidResult = value;
    },

    // 点击弹出省市区弹框
    handleShowArea() {
      this.showAreaList = true;
    },

    // 点击确定省市区选择
    handleConfirmArea(arr) {
      this.areaVal = arr[0].name + arr[1].name + arr[2].name;
      this.showAreaList = false;
      this.detailAddr = ''
    },

    // 点击取消省市区选择弹框
    handleCloseArea() {
      this.showAreaList = false;
    },

    // 点击展示填报人弹框
    handleShowPeople() {
      this.showPeopleList = true;
    },

    // 点击选择填报人
    handleChoosePeople(item) {
      this.nameId = item.id;
      this.name = item.name;
      this.showPeopleList = false;
      let arr = this.questions;
      arr.map((v, i) => {
        this.$nextTick(() => {
          if(this.$refs[`radioRef${v.questionId}`]) {
            this.$refs[`radioRef${v.questionId}`][0].radio = '';
            this.$refs[`radioRef${v.questionId}`][0].values = '';
            this.$refs[`radioRef${v.questionId}`][0].secondaryRadio = ''
          }
          if(this.$refs[`uploadRef${v.questionId}`]) {
            this.$refs[`uploadRef${v.questionId}`][0].fileList = [];
          }
          if(this.$refs[`uploadsRef${v.questionId}`]) {
            this.$refs[`uploadsRef${v.questionId}`][0].upList = [];
            this.$refs[`uploadsRef${v.questionId}`][0].fileList = [];
          }
        })
      })
      this.temperature = '';
      this.others = '';
      this.areaVal = '';
      this.detailAddr = '';
      this.citys = '';
      this.dangerPoints = '';
      this.configTemp = '';
      this.healthImg = '';
      this.travelImg = '';
      this.acidImg = '';
      this.commonImg = []
    },

    // 点击跳转新增上报人
    handleToNewPeople() {
      this.$router.push({ path: '/edit_reporter' })
    },

    // 获取上报记录列表
    async fetchRecordsList() {
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/health/submit/record',
        data: {
          pageNo: this.page,
          pageSize: 10
        }
      })
      if(res.code == 1) {
        this.records = this.records.concat(res.data);
        this.loading = false;
        if(res.data && res.data.length < 10) {
          this.finished = true
        }
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    },

    handleLoad() {
      this.page++;
      this.fetchRecordsList();
    },

    // 点击切换tab
    handleChangeTab(name) {
      if(name == 1) {
        this.records = [];
        this.page = 1;
        this.loading = false;
        this.finished = false;
        this.fetchRecordsList();
      }
    },

    // 点击填报
    async handleSubmitClick() {
      const r = this.questions.every(item => {
        if(item.required == 1 && item.questionId == 1 && this.temperatureStatus == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 1 && this.temperatureStatus == '1' && this.temperature == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 2 && this.symptomStatus == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 3 && this.others == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 4 && this.areaVal == '' && this.detailAddr == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 5 && this.isClose == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 6 && this.isTure == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 7 && this.isAsid == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 7 && this.isAsid == '1' && this.asidResult == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 8 && this.isLeave == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 8 && this.isLeave == '1' && this.leavePoint == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 9 && this.leaveWeiId == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 9 && this.leaveWeiId == '1' && this.citys == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 10 && this.dangerId == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 10 && this.dangerId == '1' && this.dangerPoints == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 11 && this.peopleId == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 12 && this.isAbroad == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 12 && this.isAbroad == '1' && this.abroadArea == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 13 && this.configTemp == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 14 && this.todayAcid == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 15 && this.yesterdayAcid == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 16 && this.checkStatus == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 17 && this.healthImg == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 18 && this.travelImg == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 19 && this.acidImg == '') {
          return false
        }
        if(item.required == 1 && item.questionId == 20 && this.commonImg.length == 0) {
          return false
        }
        return true
      })
      if(!r) {
        this.$toast({
          message: '请填写题目必填项',
          position: 'bottom'
        });
        return false
      }
      this.$dialog({
        title: '填报',
        message: '确定要填报吗？',
        showCancelButton: true
      }).then(() => {
        this._recode();
      }).catch(() => {
        this.showLoading = false;
      });
    },

    async _recode() {
      this.showLoading = true;
      const res = await post({
        url: '/api/health/submit',
        data: {
          reporterId: this.nameId,
          reporter: this.name,
          temperatureStatus: this.temperatureStatus,
          temperature: this.temperature,
          symptomStatus: this.symptomStatus,
          others: this.others,
          city: this.areaVal,
          address: this.detailAddr,
          communityStatus: this.isClose,
          diagnosisStatus: this.isTure,
          acidStatus: this.isAsid,
          acid: this.asidResult,
          outStatus: this.isLeave,
          outPoints: this.leavePoint,
          leaveStatus: this.leaveWeiId,
          leavePoints: this.citys,
          dangerStatus: this.dangerId,
          dangerPoints: this.dangerPoints,
          contactStatus: this.peopleId,
          abordStatus: this.isAbroad,
          abordCity: this.abroadArea,
          todayTemp: this.configTemp,
          todayAcid: this.todayAcid,
          yesterdayAcid: this.yesterdayAcid,
          checkStatus: this.checkStatus,
          healthImg: this.healthImg,
          travelImg: this.travelImg,
          acidImg: this.acidImg,
          commonImg: JSON.stringify(this.commonImg)
        }
      })

      if(res.code == 1) {
        this.$toast({
          message: '填报成功',
          position: 'bottom'
        });
        this.showLoading = false;
        let arr = this.questions;
        arr.map((v, i) => {
          this.$nextTick(() => {
            if(this.$refs[`radioRef${v.questionId}`]) {
              this.$refs[`radioRef${v.questionId}`][0].radio = '';
              this.$refs[`radioRef${v.questionId}`][0].values = '';
              this.$refs[`radioRef${v.questionId}`][0].valuesR = '';
              this.$refs[`radioRef${v.questionId}`][0].secondaryRadio = ''
            }
            if(this.$refs[`uploadRef${v.questionId}`]) {
              this.$refs[`uploadRef${v.questionId}`][0].fileList = [];
            }
            if(this.$refs[`uploadsRef${v.questionId}`]) {
              this.$refs[`uploadsRef${v.questionId}`][0].upList = [];
              this.$refs[`uploadsRef${v.questionId}`][0].fileList = [];
            }
          })
        })
        this.temperature = '';
        this.others = '';
        this.areaVal = '';
        this.detailAddr = '';
        this.citys = '';
        this.dangerPoints = '';
        this.configTemp = '';
        this.healthImg = '';
        this.travelImg = '';
        this.acidImg = '';
        this.commonImg = []
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
        this.showLoading = false;
      }
    }
  },
  mounted() {
    this.fetchPeople();
    this.fetchQuestions();
  }
}
</script>

<style>
.report_my_tab .van-tabs__wrap {
  height: 1rem;
  overflow: inherit;
}
.report_my_tab .van-tabs__nav--card {
  border: none;
  height: 1rem;
  justify-content: center;
}
.report_my_tab .van-tab {
  flex: none;
  width: 3rem;
  border-top: 1px solid #E0E0E0;
  border-left: 1px solid #E0E0E0;
  border-right: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
  border-radius: .1rem;
  font-size: .34rem;
  color: #333;
  font-weight: 700;
}
.report_my_tab .van-tabs__nav--card .van-tab {
  border-right: 1px solid #E0E0E0;
}

.report_my_tab .van-tab:first-child {
  margin-right: .2rem;
}
.report_my_tab .van-tab.van-tab--active {
  background:linear-gradient(-30deg,rgba(51,150,251,1) 0%,rgba(59,200,255,1) 100%);
  border: none;
}
.report_my_tab .van-tab.van-tab--active::after {
  content: '';
  position: absolute;
  top: .9rem;
  width: 0;
  height: 0;
  border-left: .25rem solid transparent;
  border-right: .25rem solid transparent;
  border-top: .3rem solid #36A8FC;
}
.report_my_tab .van-tabs__content {
  margin-top: .56rem;
}
</style>

<style scoped>
.ques_title {
  font-size: .32rem;
  line-height: .48rem;
  color: #333;
  font-weight: 700;
  margin-bottom: .34rem;
}
.ques_title > span {
  color: #FF4040;
}
.report_tab {
  margin-top: .48rem;
}
.forms_list {
  box-sizing: border-box;
  padding: 0 .25rem;
}
.record_list {
  box-sizing: border-box;
  padding: 0 .23rem;
}
.name_wrap {
  display: flex;
  align-items: center;
  margin-bottom: .56rem;
}
.name_input_wrap {
  display: flex;
  align-items: center;
}
.name_input_wrap > span {
  margin-right: .23rem;
  font-size: .32rem;
  color: #333;
  font-weight: 700;
}
.name_input {
  box-sizing: border-box;
  padding: 0 .2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 4.15rem;
  height: .9rem;
  border-radius: 5px;
  border: 1px solid #E0E0E0;
}
.name_input > span {
  font-size: .32rem;
  color: #333;
}
.name_input > img {
  width: .16rem;
  height: .1rem;
}
.add_people {
  margin-left: .3rem;
  font-size: .32rem;
  color: #1A90FF;
}
.area_wrap {
  margin-bottom: .54rem;
}
.area_title {
  font-size: .34rem;
  color: #333;
  font-weight: 700;
  margin-bottom: .34rem;
}
.text_area {
  height: 2rem;
  border-radius: 5px;
  border: 1px solid #E0E0E0;
}
.addr_selects {
  box-sizing: border-box;
  padding: 0 .25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: .9rem;
  border: 1px solid #E0E0E0;
}
.addr_selects > span {
  font-size: .32rem;
  color: #333;
}
.addr_selects > img {
  width: .16rem;
  height: .1rem;
}
.address_wrap {
  margin-bottom: .56rem;
}
.text_input {
  box-sizing: border-box;
  margin-top: .18rem;
  height: .9rem;
  font-size: .32rem;
  color: #333;
  border-radius: 5px;
  border: 1px solid #E0E0E0;
}
.btn_wrap {
  width: 6.42rem;
  margin: 0 auto;
}
.from {
  margin: .45rem 0 .35rem 0;
  font-size: .24rem;
  color: #C1C1C1;
  text-align: center;
}
.pop_school {
  box-sizing: border-box;
  padding: 0 .2rem;
  min-height: 2.5rem;
  max-height: 8rem;
}
.select_item {
  display: flex;
  align-items: center;
  height: .8rem;
  border-bottom: 1px solid #E0E0E0;
}
.select_item > p {
  font-size: .3rem;
  color: #666;
}
.select_item_ac > p {
  color: #1A8FFF;
}
.blank_input {
  display: flex;
  align-items: center;
  margin-bottom: .56rem;
}
.blank_input > span {
  font-size: .32rem;
  margin-left: .2rem;
}
.blank_input .text_input {
  width: 85%;
  margin-top: 0;
}
</style>